import React, { useCallback, useMemo } from 'react';

/* eslint-disable @atlaskit/editor/warn-no-restricted-imports */

import { ComposableEditor } from '@atlaskit/editor-core/composable-editor';
import { EditorContext } from '@atlaskit/editor-core/editor-context';
import { createDefaultPreset } from '@atlaskit/editor-core/preset-default';
import { usePreset } from '@atlaskit/editor-core/use-preset';
import { MarkdownTransformer } from '@atlaskit/editor-markdown-transformer';
import { indentationPlugin } from '@atlaskit/editor-plugins/indentation';
import { listPlugin } from '@atlaskit/editor-plugins/list';
import { maxContentSizePlugin } from '@atlaskit/editor-plugins/max-content-size';
import { toolbarListsIndentationPlugin } from '@atlaskit/editor-plugins/toolbar-lists-indentation';
import { ADFEncoder } from '@atlaskit/renderer/utils';
import { convertProsemirrorToMarkdown } from '@atlassian/ai-model-io/convert-prosemirror-to-markdown';
import { removeInvisibleCharacters } from './utils';
export var MarkdownEditor = function MarkdownEditor(_ref) {
  var value = _ref.value,
    setValue = _ref.setValue,
    setCharCount = _ref.setCharCount,
    maxCharacters = _ref.maxCharacters;
  var _usePreset = usePreset(function () {
      return createDefaultPreset({
        allowUndoRedoButtons: true,
        textFormatting: {
          responsiveToolbarMenu: true
        }
      }).add(indentationPlugin).add(listPlugin).add([toolbarListsIndentationPlugin, {
        showIndentationButtons: true,
        allowHeadingAndParagraphIndentation: false
      }]).maybeAdd([maxContentSizePlugin, maxCharacters], maxContentSizePlugin !== undefined);
    }, []),
    preset = _usePreset.preset;
  var adfEncoder = useMemo(function () {
    return new ADFEncoder(function (schema) {
      return new MarkdownTransformer(schema);
    });
  }, []);
  var initializeEditor = useCallback(function (actions) {
    var encodedValue = adfEncoder.encode(value);
    actions.replaceDocument(encodedValue);
  }, [value, adfEncoder]);
  var onEditorChange = useCallback(function (editorView) {
    var _convertProsemirrorTo = convertProsemirrorToMarkdown({
        editorView: editorView,
        fragment: editorView.state.doc.content
      }),
      markdown = _convertProsemirrorTo.markdown;
    // ? Editor component seems to add invisible characters in certain cases. Using this function to remove them and set back to the definition state.
    var markdownWithoutInvisibleChars = removeInvisibleCharacters(markdown);
    setValue(markdownWithoutInvisibleChars);
    setCharCount === null || setCharCount === void 0 || setCharCount(markdownWithoutInvisibleChars.length);
  }, [setValue, setCharCount]);
  return /*#__PURE__*/React.createElement(EditorContext, null, /*#__PURE__*/React.createElement(ComposableEditor, {
    appearance: "comment",
    preset: preset,
    shouldFocus: true,
    quickInsert: false,
    minHeight: 170,
    maxHeight: 90,
    onEditorReady: initializeEditor,
    onChange: onEditorChange
  }));
};